import { render, staticRenderFns } from "./AsideTgBtn.vue?vue&type=template&id=4f8ee3c4&"
import script from "./AsideTgBtn.vue?vue&type=script&lang=js&"
export * from "./AsideTgBtn.vue?vue&type=script&lang=js&"
import style0 from "./AsideTgBtn.vue?vue&type=style&index=0&id=4f8ee3c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports